/* eslint-disable no-loop-func */
import React, { Component } from "react";
import FichaComponent from "./../components/FichaComponent";
import SelectCity from "./../components/SelectCityComponent";

import Landing from "./../../landing/containers/LandingContainer";

import Data from "./../../constants/strings/FichasMunicipales.json";
import html2canvas from "html2canvas";

import '../style.css'

/* global jsPDF */


class FichaContainer extends Component {
  state = {
    generated: false,
    cityData: {}
  };
  handlerSubmit = (dataKey, value) => {
    if (value === "") {
      this.setState({ generated: false, cityData: {} });
    } else {
      let city = Data.filter(item => item.dane === value);
      this.setState({ generated: true, cityData: city[0] });
    }
  };

  savePdf = async () => {
    let pages = document.getElementsByClassName("work-sheet-city-card");
    var pdf = new jsPDF("p", "px", [1000, 1415]);
    for (var i = 0; i < pages.length; i++) {
      await new Promise(function(resolve) {
        html2canvas(pages[i], { scale: 1 }).then(function(canvas) {
          var img = canvas.toDataURL("image/png");
          pdf.addImage(img, "JPEG", 0, 0, 1000, 1415);
          if (i + 1 === pages.length) {
            pdf.save("infomre.pdf");
          } else {
            pdf.addPage();
          }
          resolve();
        });
      });
    }
  };
  render() {
    return (
      <Landing history={this.props.history} hasFooter={true}>
        {!this.state.generated ? (
          <SelectCity
            data={Data}
            handlerSubmit={this.handlerSubmit}
            onClose={() => {}}
          />
        ) : (
          <FichaComponent
            data={this.state.cityData}
            handlerSubmit={this.savePdf}
            onClose={() => this.setState({ generated: false, cityData: {} })}
          />
        )}
      </Landing>
    );
  }
}

export default FichaContainer;
